module.exports = __webpack_public_path__ + "static/img/female-bg-pt.0319a838.png";